module.exports = "<div class=\"capeRedirect\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-credit-components/src/redirect-to-cape/template.html
// module id = ../node_modules/xo-credit-components/src/redirect-to-cape/template.html
// module chunks = 0